<div class="source-fields">
  <mat-form-field appearance="outline" class="source" subscriptSizing="dynamic">
    <mat-label>Paid from</mat-label>
    <mat-select [(ngModel)]="details.source_account_id" (selectionChange)="remember()" [disabled]="disabled || loading" required>
      @for (s of sources; track s.id) {
      <mat-option [value]="s.id" [disabled]="!s.active">
        <mat-icon>{{ s.kind === 'Bank' ? 'account_balance' : 'account_balance_wallet' }}</mat-icon>
        <bdi>{{ s.name }}</bdi>@if (s.is_unspecified) { — unspecified }@if (!s.active) { (deactivated) }
      </mat-option>
      }
    </mat-select>
    @if (error) {
    <mat-error>{{ error }}</mat-error>
    } @else if (!loading && sources.length === 0) {
    <mat-hint>No payment accounts yet — add them under Payments → Paid-from accounts.</mat-hint>
    } @else if (selected?.is_unspecified) {
    <mat-hint class="unspecified-hint">Not one of ours (e.g. the sarraf paid directly) or not known: the accountant will assign the real account in Hesabfa.</mat-hint>
    } @else {
    <mat-hint>The account the money left from, as on the receipt.</mat-hint>
    }
  </mat-form-field>

  <div class="extras">
    @if (selected?.kind !== 'Wallet') {
    <mat-form-field appearance="outline" class="fee" subscriptSizing="dynamic">
      <mat-label>Bank fee (Toman)</mat-label>
      <input matInput type="number" min="0" step="1" [(ngModel)]="details.bank_fee" [disabled]="disabled">
    </mat-form-field>
    }
    <mat-form-field appearance="outline" class="ref" subscriptSizing="dynamic">
      <mat-label>Tracking number</mat-label>
      <input matInput [(ngModel)]="details.transaction_ref" maxlength="100" [disabled]="disabled" dir="ltr">
    </mat-form-field>
  </div>
</div>
